import * as THREE from 'three'
import type { GLTF } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { ImportedModelObjectMetadataService } from '../metadata'
import { asRecord } from './utils'

function readNodeOriginalName(nodeValue: unknown): string | undefined {
  const nodeRecord = asRecord(nodeValue)
  if (!nodeRecord) {
    return undefined
  }
  const rawName = typeof nodeRecord.name === 'string' ? nodeRecord.name.trim() : ''
  return rawName.length > 0 ? rawName : undefined
}

export function readImportedOriginalName(object: THREE.Object3D): string | undefined {
  return ImportedModelObjectMetadataService.resolveOriginalName(object)
}

export function resolveImportedDisplayName(
  object: THREE.Object3D,
  fallbackName: string,
): string {
  return readImportedOriginalName(object) ?? fallbackName
}

export function applyOriginalNodeNamesToScene(gltf: GLTF): void {
  const parser = (gltf as unknown as { parser?: unknown }).parser
  if (!parser) {
    return
  }

  const parserJson = (parser as {
    json?: { nodes?: unknown[] }
  }).json
  const associationMap = (parser as {
    associations?: unknown
  }).associations

  const nodeItems = Array.isArray(parserJson?.nodes) ? parserJson.nodes : []
  const associations = associationMap instanceof Map
    ? associationMap as Map<unknown, unknown>
    : null

  if (!associations || nodeItems.length === 0) {
    return
  }

  gltf.scene.traverse((object) => {
    const associationRecord = asRecord(associations.get(object))
    const nodeIndex = typeof associationRecord?.nodes === 'number' ? associationRecord.nodes : null
    if (nodeIndex === null || nodeIndex < 0 || nodeIndex >= nodeItems.length) {
      ImportedModelObjectMetadataService.writeMetadata(object, { originalName: undefined })
      return
    }

    const originalName = readNodeOriginalName(nodeItems[nodeIndex])
    if (originalName) {
      ImportedModelObjectMetadataService.writeMetadata(object, { originalName })
      return
    }

    ImportedModelObjectMetadataService.writeMetadata(object, { originalName: undefined })
  })
}
